import React from "react";
import Application from "shared/containers/application";
import UpdatePassword from "./update-password";

function UpdatePasswordWrapper(props) {
  return (
    <Application>
      <UpdatePassword />
    </Application>
  );
}

export default UpdatePasswordWrapper;



// WEBPACK FOOTER //
// ./src/account/components/update-password-wrapper.js